import api from '@/lib/api/axios'

export interface DashboardStats {
    jobsScheduledToday: number
    failedLast24h: number
    agentsOnline: number
    totalJobs: number
    activeJobs: number
    completedJobs: number
    failedJobs: number
}

export interface ActivityItem {
    id: number
    type: 'job_started' | 'job_completed' | 'job_failed' | 'user_login'
    message: string
    timestamp: string
    metadata?: Record<string, any>
}

export interface JobMetric {
    date: string
    completed: number
    failed: number
    running: number
}

export interface DashboardOverview {
    objects: number
    services: number
    versions: number
    redObjects: number
    amberObjects: number
    greenObjects: number
    greyObjects: number
    locations: number
    vaults: number
    users: number
    masterRunbooks: number
    objectRunbooks: number
    scenarios: number
    teams: number
    technologies: number
    openRecoveries: number
    completedRecoveries: number
    pendingApprovals: number
    runbookTaskStats: { pending: number; started: number; completed: number; issue: number }
    runbookCoverage: number
    securityScans: { scanned: number; anomalies: number; total: number }
    objectsByLocation: Array<{ location: string; count: number }>
    objectsByLayer: Array<{ layer: string; layerId: number; count: number }>
    recoveryByMonth: Array<{ month: string; count: number }>
    recentRecoveries: Array<{ requestID: number; objectID: string; status: string; dateRequested: string }>
}

export const dashboardApi = {
    getStats: () =>
        api.get<DashboardStats>('/api/dashboard/stats'),

    getRecentActivity: () =>
        api.get<ActivityItem[]>('/api/dashboard/activity'),

    getJobMetrics: (period: '24h' | '7d' | '30d') =>
        api.get<JobMetric[]>(`/api/dashboard/metrics/${period}`),

    getOverview: () =>
        api.get<{ success: boolean; data: DashboardOverview }>('/api/dashboard/overview'),
}



